import React, { useState } from "react";
import { Route, Switch, Link } from "react-router-dom";
import { Authenticator } from "aws-amplify-react";
import Amplify, { Auth } from "aws-amplify";
import NavDrawer from "storybookComponents/NavDrawer";
import "./icons/style.css";
import { makeStyles } from "@material-ui/core";
import { CalendarIcon, ApprovalIcon, ReportIcon, CogIcon } from "icons";
import * as path from "constants/path";
import { NAVBAR_WIDTH } from "constants/index";
import Loader from "storybookComponents/Loader";
import UserContext from 'context/UserContext';
import HomePage from "content/HomePage";
import { getPropertyId, setProperty, getUserRole, getUserEmail, setPropertyIdLocalStorage, premiumApps, globalTohyMail } from "common"
import environment from "environments/environment";
import { useCustomEventListener } from 'react-custom-events';
import { EVENT_CODES } from 'constants/index';
import UnAuthorizedUserPage from "./public-routes/unauthorized";
import { getDefaultOrg, getSuborgDetails } from "relay/event"
import { getPremiumDetails } from "relay/main"
import Content from "./appContent";
import Storage from "common/localStorage"
import { getTimeZoneString } from "./data/timezoneList"
import { checkIfEmailExist } from "content/utils/commonParsing";
import { getNavDrawerMenu } from "./navDrawerMenu";
import { _getApps } from "components/AppSwitcher/apis";
import _ from "lodash";
import { compare } from "content/utils/commonParsing";
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100vh'
  },
  appConatiner: {
    margin: -16
  },
  contentWrapperShift: {
    marginLeft: NAVBAR_WIDTH,
    width: `calc(100% - ${NAVBAR_WIDTH}px)`,
    height: '100%',
    flex: 1,
    display: 'flex',
    flexGrow: 1,
    flexFlow: 'column',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  contentWrapperNoShift: {
    width: '100%',
    height: '100%',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    paddingLeft: "20px",
  },
  appBarShift: {
    marginLeft: NAVBAR_WIDTH,
    width: `calc(100% - ${NAVBAR_WIDTH}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    paddingLeft: "20px",
  },
}));

const authConfig = {
  Auth: {
    userPoolId: process.env.REACT_APP_UserPool,
    userPoolWebClientId: process.env.REACT_APP_ClientId,
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL,
    authenticationFlowType: "USER_PASSWORD_AUTH",
    cookieStorage: {
      domain: process.env.REACT_APP_domain,
      path: "/",
      expires: 7,
      secure: process.env.NODE_ENV === "production",
    },
  },
};

Amplify.configure(authConfig);

const getAuthState = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user;
  } catch (err) {
    console.warn("getAuthState error: ", err.message || err);
    return undefined;
  }
};

const accountsLink = process.env.REACT_APP_ACCOUNTS_LINK

function HyEvent({ appSwitcher, user, userName, userEmail, orgSuborgApproverSettings, ...rest }) {
  const classes = useStyles();
  const { subOrgDetails, setSuborgDetails, setUserRole } = React.useContext(UserContext);
  const [propertyId, setPropertyId] = React.useState(subOrgDetails.id)
  const [orgLevel, setOrgLevel] = React.useState(false);
  const [approvalSubmenuTabs, setApprovalSubmenuTabs] = React.useState();
  const [apps, setApps] = React.useState([]);
  const _userRole = getUserRole();
  const [hyeventsAccessApproval, setHyeventAccessApproval] = React.useState(true);
  const [appsLoading, setLoading] = React.useState(true);
  const [menuItems, setMenuItems] = React.useState();
  const [expiredAt, setExpiredAt] = React.useState(null);
  const [auth, setAuth] = React.useState(true);
  const setData = async (property) => {
    let urlKeys = window.location.pathname.split('/');
    let drawerValue = ""
    if (urlKeys.length == 3) {
      if (urlKeys[2] !== "/") {
        drawerValue = "/" + urlKeys[2];
      }
    }
    setPropertyIdLocalStorage(property.id);
    setOrgLevel(property.orgLevel);
    let timezoneString = getTimeZoneString(property.timezone)
    let subOrgDetails = await getSuborgDetails(property.id);
    setSuborgDetails({ ...subOrgDetails.authorizedSuborgs[0], ...property, timezoneString })
    window.localStorage.setItem("userEmail", property.userEmail)
    rest.history.push(path.getAppPath(property.id) + drawerValue)
    getApps(property.org.id, property.id, property.orgLevel, approvalSubmenuTabs);
  }

  const secondaryMenu = [{
    path: "/",
    name: "My Account",
    href: `${process.env.REACT_APP_ACCOUNTS_LINK}`,
    target: "_blank",
    rel: "noreferrer",
  },];


  React.useEffect(() => {
    setUserRole(_userRole)
    let approvalSubmenuTabs = getApprovalTabsDetails()
    setApprovalSubmenuTabs(approvalSubmenuTabs);
    getApps(subOrgDetails.org.id, subOrgDetails.id, false, approvalSubmenuTabs);
  }, [1])

  const getApprovalTabsDetails = () => {
    if (_userRole !== "property_manager") {
      return "approver"
    }
    const { hyeventsSetting, org } = orgSuborgApproverSettings;
    if (_userRole == "property_manager") {
      if (
        checkIfEmailExist(hyeventsSetting.approverEmails, userEmail) ||
        checkIfEmailExist(org.hyeventsSetting.approverEmails, userEmail)
      ) {
        return "approver"
      }
    }
    return "agent"
  };

  const getModulesDetailsForAuthorization = (apps, suborgId, orgLevel) => {
    let journeyAIModules = [];
    for (let i = 0; i < apps.length; i++) {
      if (premiumApps.includes(apps[i].name)) {
        const { name, url, orgLevelUrl } = globalTohyMail[apps[i].name];
        journeyAIModules.push({
          id: `journeyAIModules_${name}`,
          name: name === "Raf" ? "Refer-a-Friend" : name,
          title: name,
          unauthUser: apps[i].access === "none" && apps[i].authorized,
          premium: !apps[i].authorized,
          journeyAIModules: true,
          url: `${process.env.REACT_APP_JAI_hostName}/${suborgId}/${url}`
        });

        //If an org/suborg is using hyBlast then they are eligible to use Success center Blast automatically
        //It may change later when we will add success center drips
        if (name === "Blasts") {
          journeyAIModules.push({
            id: `journeyAIModules_Success Center`,
            name: "Success Center",
            title: "Success Center",
            unauthUser: apps[i].access === "none" && apps[i].authorized,
            premium: !apps[i].authorized,
            journeyAIModules: true,
            url: process.env.REACT_APP_JAI_hostName + "/" + suborgId + "/hyblast/analysis",
          });
        }
      }
    }

    return journeyAIModules.slice().sort((a, b) => compare(a.name, b.name, false));
  };



  const getApps = async (orgId, suborgId, orgLevel, approvalSubmenuTabs) => {
    try {
      setLoading(true);
      let response = await _getApps(orgId, orgLevel ? null : suborgId);
      if (response.length > 1) {
        let authorizedDetails = getModulesDetailsForAuthorization(
          response,
          suborgId,
          orgLevel,

        );
        let isApprover;
        setApps([...response, ...authorizedDetails]);
        let hyeventsDetails = response.find((app) => app.name == "hyEvents");
        if (hyeventsDetails) {
          setAuth(hyeventsDetails.authorized)
          setExpiredAt(hyeventsDetails.expiredAt)
          if (hyeventsDetails.expiredAt) {
            if (!hyeventsDetails.authorized) {
              rest.history.push(`/${suborgId}/unauthorized`)
            } else if (new Date() > new Date(hyeventsDetails.expiredAt)) {
              rest.history.push(`/${suborgId}/expired`)
            }
          }
          isApprover = _userRole === "admin" ||
            (_userRole === "regional_manager" && hyeventsDetails.access === "admin")
          setHyeventAccessApproval(isApprover);
        }
        const data = await getNavDrawerMenu(
          path.getAppPath(suborgId),
          approvalSubmenuTabs == "approver",
          orgLevel,
          hyeventsAccessApproval
        );
        setMenuItems(data);
      } else {
        setApps([]);
      }
      setLoading(false);
    } catch (err) {
      console.log("Err", err);
    }
  };

  const setOriginNavItems = async (ol = false) => {
    setOrgLevel(ol);
    const menu = await getNavDrawerMenu(
      path.getAppPath(subOrgDetails.id),
      approvalSubmenuTabs == "approver",
      ol,
      hyeventsAccessApproval
    );
    setMenuItems(menu);
  };



  const handleSignOut = async () => {
    try {
      await localStorage.clear();
      window.location.assign(`${accountsLink}/logout?goto=hyEvents`);
    }
    catch (err) {
      console.error('logout error: ', err);
    }
  };

  const parsePath = (p) => {
    if (p.startsWith(path.getAppPath() + "/event")) {
      return path.getAppPath()
    }
    return p;
  }

  const setSuborgData = (property) => {
    let timezoneString = getTimeZoneString(subOrgDetails.timezone);
    setOrgLevel(property.orgLevel);
    setSuborgDetails({ ...property, timezoneString });
  };

  const handleSelectProperty = (row) => {
    let data = {
      ...row[1],
      org: {
        id: row[0].id,
        name: row[0].name,
      },
      orgLevel: false,
      userEmail: userEmail,
    };
    setData(data);
  };

  const handleSelectOrg = (org) => {
    if (org.suborgs) {
      let data = {
        ...org.suborgs[0],
        org: {
          id: org.id,
          name: org.name,
        },
        orgLevel: true,
        userEmail: userEmail,
      };
      setData(data);
    } else {
      setSuborgData({
        ...subOrgDetails,
        orgLevel: true,
      });
      getApps(subOrgDetails.org.id, subOrgDetails.id, true, approvalSubmenuTabs);
    }
  };

  return (
    <NavDrawer
      environment={environment}
      user={{
        name: userName || userEmail,
        ...user
      }}
      // path={window.location.pathname}
      user_name={user && user.attributes && user.attributes.name}
      user_email={(user.attributes && user.attributes.email) || (user.identities && user.identities.email)}
      access={true}
      org={{
        id: subOrgDetails.org.id
      }}
      property={{
        id: subOrgDetails.id,
        propertyLogoUrl: subOrgDetails.propertyLogoUrl,
        propertyManagerLogoUrl: subOrgDetails.propertyManagerLogoUrl,
      }}
      propertyId={subOrgDetails.id}
      initialIDValue={propertyId}
      authorized={true}
      orgLevel={false}
      menu={menuItems}
      handleNotification={() => { }}
      link_component={Link}
      header_props={secondaryMenu}
      suborg_change_available={true}
      onSelectOrg={handleSelectOrg}
      onSelectProperty={handleSelectProperty}
      is_online={true}
      logout_function={handleSignOut}
      updateDimensions={() => { }}
      handleNavDrawer={(data) => {
        console.log("handleNavDrawer : ", data)
      }}
      pathname={parsePath(rest.location.pathname)}
      appName="hyEvents"
    >
      <Content
        classes={classes}
        user={user}
        orgLevel={subOrgDetails.orgLevel}
        propertyId={subOrgDetails.id}
        org={{ id: subOrgDetails.org.id }}
        userRole={_userRole}
        orgLevelVisible={orgLevel}
        setOriginNavItems={setOriginNavItems}
        hyeventsAccessApproval={hyeventsAccessApproval}
        approvalSubmenuTabs={approvalSubmenuTabs}
        apps={apps}
        expiredAt={expiredAt}
        unauth={!auth}
        isExpired={expiredAt && new Date() > new Date(expiredAt)}
        {...rest}
      />
    </NavDrawer>
  )
}



const App = (props) => {
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const [userName, setUserName] = React.useState();
  const [userEmail, setUserEmail] = React.useState();
  const [orgSuborgApproverSettings, setOrgSuborgAppoverSetting] = React.useState([]);


  const { setSuborgDetails } = React.useContext(UserContext);

  const handleSignin = () => {
    window.location.href = `${accountsLink}?goto=hyEvents`;
  };

  const getNameEmail = (user) => {
    if (user && user.attributes) {
      if (user.attributes.email || user.attributes.name) {
        return {
          email: user.attributes.email,
          name: user.attributes.name,
        }
      } else if (user.attributes.identities) {
        let identities = JSON.parse(user.attributes.identities);
        return {
          email: identities[0].userId,
          name: identities[0].userId,
        }
      } else {
        return null;
      }
    } else {
      return null
    }
  }

  React.useEffect(() => {
    if (window.location.hostname === "localhost") {
      loadProperty("iq+admin@hy.ly")
      return
    }
    loadUser()
  }, [1]);

  const loadUser = async () => {
    try {
      const user = await getAuthState();
      console.log("user : ", user)
      let userDetails = getNameEmail(user);
      if (userDetails) {
        setUserEmail(userDetails.email);
        setUserName(userDetails.name)
      }
      setUserData(user);
      if (user && userDetails && userDetails.email) {
        loadProperty(userDetails.email);
      }
      else
        if (window.location.href.includes('from=myhyly')) {
          window.location.href = `${accountsLink}?goto=hyEvents`;
        } else {
          setLoading(false);
        }

    }
    catch (err) {
      setLoading(false)
    }
  }

  const getOrgData = async (userEmail) => {
    await window.localStorage.clear();
    let defaultOrg = await getDefaultOrg("Events");
    if (defaultOrg.authorizedOrgs && defaultOrg.authorizedOrgs.length) {
      let org = defaultOrg.authorizedOrgs[0];
      let property = org.suborgs[0];
      setProperty({
        ...property,
        orgid: org.id,
        userEmail: userEmail,
        userRole: org.userRole
      })
    }
  }


  const loadProperty = async (userEmail) => {
    setLoading(true)
    let propertyId = getPropertyId(true);
    let _userEmail = getUserEmail();
    if ((!propertyId && propertyId.length !== 36) || userEmail !== _userEmail) {
      await getOrgData(userEmail)
    } else {
      try {
        let subOrgDetails = await getSuborgDetails(propertyId);
        if (subOrgDetails && subOrgDetails.authorizedSuborgs && subOrgDetails.authorizedSuborgs[0]) {
          setOrgSuborgAppoverSetting({
            hyeventsSetting: subOrgDetails.authorizedSuborgs[0].hyeventsSetting,
            org: {
              hyeventsSetting: subOrgDetails.authorizedSuborgs[0].org.hyeventsSetting,
            },
          });
          let timezoneString = getTimeZoneString(subOrgDetails.authorizedSuborgs[0].timezone)
          setSuborgDetails({
            ...subOrgDetails.authorizedSuborgs[0],
            orgLevel: false,
            timezoneString
          });
        } else {
          await getOrgData(userEmail);
        }
      } catch (err) {
        console.log("Err", err)
        handleUnAuth();
      }
    }
    setLoading(false)
  }


  const handleUnAuth = () => {
    window.location.href = "/unauthorized"
  }

  useCustomEventListener(EVENT_CODES.UNAUTH_USER, handleUnAuth);

  if (window.location.hostname === "localhost") {
    return loading ? <Loader /> : <HyEvent
      userName="IQ Admin"
      userEmail="iq+admin@hy.ly"
      user={{
        attributes: {
          email: "iq+admin@hy.ly",
          email_verified: true,
          name: "IQ Admin",
          sub: "14d603dd-5bc8-4eee-beed-14bd827b6578",
        },
        username: "iq+admin@hy.ly",
      }} {...props} orgSuborgApproverSettings={orgSuborgApproverSettings} />
  }

  return loading ? <Loader /> :
    (
      <>
        {!userData ?
          <HomePage
            handleSignin={handleSignin}
          /> :
          <Authenticator hideDefault={true}>
            <HyEvent userName={userName} userEmail={userEmail} user={userData} orgSuborgApproverSettings={orgSuborgApproverSettings} {...props} />
          </Authenticator>
        }
      </>
    );
}

export default () => {

  return (
    <Switch>
      <Route path="/unauthorized" component={UnAuthorizedUserPage} />
      <Route path="/" component={App} />
    </Switch>

  )
}